import React from "react";
import {
  fetchMedicalRecords,
} from "../../../actions/medicalRecords";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import { NavLink } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import classnames from "classnames";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Responsive from "react-responsive";

const $ = window.$;
const { SearchBar } = Search;
const petAvailabilityStatus = {
    available:"available",
    sold:"sold",
    medicalRecordAvailable:"Available"
};

const MEDICALRECORD_TYPES ={
  AVAILABLE : 'Available',
  SOLD : "Sold",
};
var _self;
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal'

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    availableMedicalRecords: [],
    soldMedicalRecords:[],
    selectedTab: "Available", 
    avatar_file_name: "",
    avatar_path: "",
  };

  tableHeaderColumnData = [

    {
      dataField: "pet_id",
      text: "Pet Id",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
           <span className="m-badge m-badge--info mx-auto my-0 px-2">
            <strong>
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.id}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
              >
              <span className="m-badge m-badge--info mx-auto my-0 px-2">
                <strong>{cell}</strong>
              </span>
             </a>   
            </strong>
           </span> 
      
          </span>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },

    {
      dataField: "color_markings",
      text: "Color",
      sort: true
    },
    {
      dataField: "date_of_birth",
      text: "Date Of Birth",
      formatter: cell => moment(new Date(cell.replace(/-/g, "/"))).format("MM-DD-YYYY"),
      sort: true
    },
     {
      dataField: "arrival_date",
      text: "Arrival Date",
      formatter: cell => moment(new Date(cell.replace(/-/g, "/"))).format("MM-DD-YYYY"),
      sort: true
    }, 

    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          { row.woo_pet_availability === petAvailabilityStatus.available ?
          <div>
          <span
            className={
              "m-badge mx-auto my-0 px-2 " +
              (cell === "Available"
                ? "m-badge--success"
                : cell === "Sold"
                  ? "m-badge--danger mb-2"
                  : " m-badge--wide")
            }
          >
            <strong>{cell}</strong>         
          </span> 
          <br/>
            { row.Contract != null ? 
              <span
                className="m-badge mx-auto my-0 px-2 m-badge--success"
              >
               {row.Contract.Customer ? row.Contract.Customer.firstname: ''}
              </span>:""   
            }
            </div>
            :<div>
            {row.woo_pet_availability === petAvailabilityStatus.sold && row.Contract == null && (               
            <div>
              <span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                <strong>Sold</strong> 
              </span>
              <br/>
              <span className="m-badge mx-auto my-0 px-1 m-badge--warning">
                <strong>No Contract</strong> 
              </span>
            </div>
            )}                  
            </div>}  
          </div>
        );
      }
    }
  ]; 


  componentDidMount() {
    this.props.fetchMedicalRecords(); 
  }

  componentWillReceiveProps =  nextProps => {

    if (nextProps.data.medicalRecordsReducer.mRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords.length > 0 &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords !==
      this.props.data.medicalRecordsReducer.mRecords.medicalRecords 
    ) {
      let records = nextProps.data.medicalRecordsReducer.mRecords.medicalRecords;      
      records.sort((a, b) => (a.id > b.id ? -1 : 1));  
      let availableMedicalRecords = records.filter(     
        m => m.status ===  petAvailabilityStatus.medicalRecordAvailable &&
        m.woo_pet_availability === petAvailabilityStatus.available
      );    
      
      let soldMedicalRecords = records.filter(   
        m => m.status ===  MEDICALRECORD_TYPES.SOLD || m.woo_pet_availability === petAvailabilityStatus.sold
      );

        this.setState({ availableMedicalRecords: availableMedicalRecords, soldMedicalRecords : soldMedicalRecords });
    }  

  };

  items = [{ title: "Puppy Records", }];

  render() {
    const { classes, theme } = this.props;
    const {  
      availableMedicalRecords,   
      soldMedicalRecords,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Puppy Records
                        <small>List of all the available medical records</small>
                      </h3>
                    </div>
                  </div>            
                </div>
                <div className="m-portlet__body medical-record-content">    
                <ul
                  className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                  role="tablist"
                >
         
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === MEDICALRECORD_TYPES.AVAILABLE
                        })}
                        onClick={() =>
                          this.setState({ selectedTab: MEDICALRECORD_TYPES.AVAILABLE })
                        }
                      >
                        Available
                      </a>
                    </li>     
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === MEDICALRECORD_TYPES.SOLD
                        })}
                        onClick={() => this.setState({ selectedTab: MEDICALRECORD_TYPES.SOLD })}
                      >
                        Sold
                      </a>
                    </li>    
                  </ul>           
                  <div className="tab-content">
                    <ToolkitProvider
                      keyField="id"
                      data={ this.state.selectedTab === MEDICALRECORD_TYPES.AVAILABLE ? availableMedicalRecords: this.state.selectedTab ===  MEDICALRECORD_TYPES.SOLD ? soldMedicalRecords:[]}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>
                          <div className="mb-2">                       
                          </div>                   
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />                     
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>              
            </div>
          </div>
        </div>         
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = state => ({
  data: state,

});

const mapDispatchToProps = dispatch => ({
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);

